import { JudgementStatus } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateJudgementStatus: (
  fetchContext: FetchContext,
  nominationId: number,
  userId: number,
  judgementStatus: JudgementStatus,
  countryId?: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, userId, judgementStatus, countryId, accessToken) => {
  const countryPath = countryId === undefined ? '' : `/country/${countryId}`;

  return fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/judges/${userId}${countryPath}/judgement-status`,
  {
    method: 'PUT',
    body: JSON.stringify(judgementStatus),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update judgement status'));
};
